import { useAppDispatch, useAppSelector } from 'app/state'
import { setTakeOverResponseState } from 'features/builder/state/builderSlice'
import { useTakeoverResponseAction } from 'features/builder/hooks/collaboration'
import { RequestStatus, ResourceType } from 'features/common'
import { TakeResponseDialogResult } from 'features/collaboration/types'
import TakeOverResponseDialog from 'features/collaboration/ui/takeOver/TakeOverResponseDialog'

export type BuilderTakeOverResponseDialogProps = {
  open: boolean
  onFinished: (result: TakeResponseDialogResult) => void
}

function BuilderTakeOverResponseDialog({ open, onFinished }: BuilderTakeOverResponseDialogProps) {
  const dispatch = useAppDispatch()

  const currentMap = useAppSelector((state) => state.maps.currentMap)
  const takeOverResponseState = useAppSelector((state) => state.builder.takeOverResponseState)

  const isSaving = useAppSelector((state) => state.maps.mapEditStatus === RequestStatus.Pending)

  const { mutateAsync: takeOverActionResponse } = useTakeoverResponseAction()

  const handleAccept = async () => {
    if (!currentMap) return

    await takeOverActionResponse({ mapId: currentMap.id, action: 'accept' })

    dispatch(setTakeOverResponseState({ ...takeOverResponseState, accepted: true }))
    onFinished('accepted')
  }

  const handleReject = () => {
    if (!currentMap) return

    takeOverActionResponse({ mapId: currentMap.id, action: 'reject' })
    onFinished('rejected')
  }

  if (!takeOverResponseState?.requestedTime) return null

  return (
    <TakeOverResponseDialog
      resourceType={ResourceType.Map}
      open={open}
      onAccept={handleAccept}
      onReject={handleReject}
      isLoading={isSaving}
      user={takeOverResponseState?.email}
      timeout={takeOverResponseState.requestedTime}
      onTimeoutExpired={() => onFinished('canceled')}
    />
  )
}

export default BuilderTakeOverResponseDialog
